'use client'

import { useFormContext } from 'react-hook-form'
import { Bounce } from 'react-toastify'

import {
  AccountToastProvider,
  useAccountVerification,
} from '@/features/update-account'
import { AccountForm } from '@/features/update-account'
import { DefaultToastStyle, Spinner } from '@/shared/ui'

export const HostPayAccount = () => {
  const { setValue } = useFormContext()

  const { isAccountVerified, markAsUnverified, action } =
    useAccountVerification()

  const handleEditButtonClick = () => {
    setValue('accountHolder', '')

    if (isAccountVerified) {
      markAsUnverified()
    }
  }

  return (
    <div className="space-y-3">
      <h3 className="typo-body1 font-semibold text-black">
        정산 대금 입금 계좌
      </h3>
      <AccountToastProvider
        autoClose={5000}
        toastClassName={DefaultToastStyle}
        transition={Bounce}
      />
      <AccountForm onEditButtonClick={handleEditButtonClick} />
      {action.isExecuting && (
        <Spinner className="fixed rounded-xl bg-black/20" />
      )}
    </div>
  )
}
